const setThreadDiffCard = ({ threadId, diffCard } = {}) => {
  return {
    type: 'pieveSetThreadDiffCard',
    payload: { threadId, diffCard: diffCard || null }
  };
};

export default setThreadDiffCard;
